export default {
    namespaced: true,
    state: {
        report_initial_values: {},
        foreign_vat_report_initial_values: {},
        belgian_vat_report_initial_values: {},
        eu_services_report_initial_values: {},
    },
    getters: {
        getReportInitialValues: state => state.report_initial_values,
        getForeignVATReportInitialValues: state => state.foreign_vat_report_initial_values,
        getBelgianReportInitialValues: state => state.belgian_vat_report_initial_values,
        getEUServicesReportInitialValues: state => state.eu_services_report_initial_values
    },
    mutations: {
        setReportInitialValues (state, report_initial_values) {
            state.report_initial_values = report_initial_values;
        },
        setForeignVATReportInitialValues (state, foreign_vat_report_initial_values) {
            state.foreign_vat_report_initial_values = foreign_vat_report_initial_values;
        },
        setBelgianReportInitialValues(state, vat_report_initial_values){
            state.belgian_vat_report_initial_values = vat_report_initial_values;
        },
        setEUServicesReportInitialValues(state, eu_services_report_initial_values) {
            state.eu_services_report_initial_values = eu_services_report_initial_values;
        }
    }
}